module.exports = __webpack_public_path__ + "img/cert1.3aa8bbe6.jpg";